import React from 'react'
import { Navigate } from 'react-router-dom';
import { getStoredIdToken } from '../authToken';


interface PrivateRouteProps{
    children: any
}
const PrivateRoute: React.FC<PrivateRouteProps> = ({children}) => {
  const isAuthenticated = getStoredIdToken();
  if(isAuthenticated){
    return children
  }else{
    return <Navigate to='/login' replace/>
  }
}

export default PrivateRoute
